'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var CID = require('cids');

var errCode = require('err-code');

var resolve = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid, name, path, toResolve, _resolve, depth, ipld, options) {
    var node, subObject, subPath, prop;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return ipld.get(cid, options);

          case 2:
            node = _context.sent;
            subObject = node;
            subPath = path;

          case 5:
            if (!toResolve.length) {
              _context.next = 18;
              break;
            }

            prop = toResolve[0];

            if (!(prop in subObject)) {
              _context.next = 15;
              break;
            }

            // remove the bit of the path we have resolved
            toResolve.shift();
            subPath = "".concat(subPath, "/").concat(prop);

            if (!CID.isCID(subObject[prop])) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", {
              entry: {
                name: name,
                path: path,
                cid: cid,
                node: node,
                depth: depth
              },
              next: {
                cid: subObject[prop],
                name: prop,
                path: subPath,
                toResolve: toResolve
              }
            });

          case 12:
            subObject = subObject[prop];
            _context.next = 16;
            break;

          case 15:
            throw errCode(new Error("No property named ".concat(prop, " found in cbor node ").concat(cid.toBaseEncodedString())), 'ERR_NO_PROP');

          case 16:
            _context.next = 5;
            break;

          case 18:
            return _context.abrupt("return", {
              entry: {
                name: name,
                path: path,
                cid: cid,
                node: node,
                depth: depth
              }
            });

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function resolve(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = resolve;